import { useEffect } from "react"
import type { ReactElement } from "react"
import { connect } from "react-redux"
import type { Dispatch } from "redux"

import { MapViewerPanel, mapViewerClearEditPanels } from "../../../redux"
import type { AppState } from "../../../redux"
import { LeafletTopLeft } from "../../../utils"
import { MapControl, MapControlContainer } from "../../atoms"
import {
  ColorSwatchPanel,
  DrawArrowControl,
  DrawCircleControl,
  DrawPencilControl,
  DrawSquareControl,
  DrawTextControl,
  MapSelectionControl
} from "../../molecules"

import "./map-drawing-controls.styles.scss"

export interface IMapDrawingControlsStateProps {
  isOpen?: boolean
  disableText: boolean
  showColorPanel: boolean
  clearEditPanels: () => void
}

function MapDrawingControlsView(props: IMapDrawingControlsStateProps): ReactElement {
  const { isOpen, disableText, showColorPanel, clearEditPanels } = props
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    if (!isOpen) {
      clearEditPanels()
    }
  }, [isOpen])

  return !isOpen ? (
    <></>
  ) : (
    <MapControlContainer position={LeafletTopLeft} className="map-drawing-controls-container">
      <MapControl>
        <MapSelectionControl />
        <DrawPencilControl />
        <DrawTextControl disabled={disableText} />
        <DrawArrowControl />
        <DrawSquareControl />
        <DrawCircleControl />
      </MapControl>
      {showColorPanel && (
        <MapControl>
          <ColorSwatchPanel />
        </MapControl>
      )}
    </MapControlContainer>
  )
}

function mapStateToProps(state: AppState) {
  return {
    isOpen: state.mapViewer.panels.get(MapViewerPanel.Drawing),
    showColorPanel: state.mapViewer.panels.get(MapViewerPanel.DrawPencil) || false
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    clearEditPanels: () => dispatch(mapViewerClearEditPanels())
  }
}

export const MapDrawingControls = connect(mapStateToProps, mapDispatchToProps)(MapDrawingControlsView)
